import React from "react";
import { useTranslation } from "react-i18next";
import { images } from "assets/images";

type AnnouncementProp = {
  children?: string | React.ReactNode;
};

const Announcement = ({ children }: AnnouncementProp) => {
  const { t } = useTranslation();
  return (
    <div className="whiteContainer flex margin-verticaly">
      <span className="img-container">
        <img src={images.exclamationCircle} alt={t("exclamationCircle")} />
      </span>

      <span>{children}</span>
    </div>
  );
};

export default Announcement;
